import { render, staticRenderFns } from "./vocational education.vue?vue&type=template&id=7a384d66&scoped=true&"
import script from "./vocational education.vue?vue&type=script&lang=js&"
export * from "./vocational education.vue?vue&type=script&lang=js&"
import style0 from "./vocational education.vue?vue&type=style&index=0&id=7a384d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a384d66",
  null
  
)

export default component.exports